<template>
  <div id="pageRoot">
    <img id="bg" src="/pages/img/sordoglo/svgGlo24bg.svg" />
    
    <div
      class="pageElement text-box-a hover-animation-a"
      id="textBox01"
      style="background-image: url(/pages/img/sordo/svgPage78Textbox01.svg)"
    >
      <p class="textBase" id="textBox01Text">
        Escribe el título<br />
        que señalaste en<br />
        la tapa del libro.
      </p>
    </div>

    <div id="tag01" class="tag" style="z-index: 3; top: 50px" ref="tg1">
      <p class="textBase pageElement tagText">El zapato Glo Glo Glo</p>
    </div>
    <div id="tag02" class="tag" style="z-index: 3; top: 110px" ref="tg2">
      <p class="textBase pageElement tagText">El sapito Clo Clo Clo</p>
    </div>
    <div id="tag03" class="tag" style="z-index: 3; top: 170px" ref="tg3">
      <p class="textBase pageElement tagText">El sapito Glo Glo Glo</p>
    </div>
    <div id="tag04" class="tag" style="z-index: 3; top: 230px" ref="tg4">
      <p class="textBase pageElement tagText">El sapo Glo Glo Glo</p>
    </div>

    <div
      class="pageElement appearAnimationA"
      id="book"
      style="background-image: url(/pages/img/sordoglo/svgGlo24Book.svg)"
    >
      <saved-input
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="1"
        id="inputField01"
        class="pageElement"
        style="z-index: 7"
      />
    </div>

    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
    <span class="footer-page footer-write"></span>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 48px;
  top: 48px;
  visibility: hidden;
}
#inputField01 {
  position: absolute;
  width: 340px;
  height: 42px;
  left: 100px;
  top: 100px;
}

#textBox01 {
  position: absolute;
  width: 363px;
  height: 313.35px;
  left: 616px;
  top: 402px;
}
#textBox01Text {
  position: absolute;
  width: 296px;
  height: 151px;
  left: 44px;
  top: 45px;
  font-size: 36px;
  line-height: 49px;
  color: #fbf8f8;
}
.tag {
  position: absolute;
  width: 400px;
  height: 70.55px;
  right: 10px;
  background-image: url(/pages/img/sordo/svgPage71TagLongOFF.svg);
  background-size: cover;
  transform: scale(0.8);
  transition: 0.3s;
}
.tag:hover {
  transform: translateY(-10px) scale(0.9);
}
#book {
  position: absolute;
  width: 606px;
  height: 588px;
  left: 48px;
  top: 142px;
  z-index: 0;
}
</style>

<script>
export default {
  data() {
		return {
			videos: ["glo/Video 115.mp4"]
		};
	},
  computed: {
    dbId() {
      //78 because we refer to the option selected on page 117, that is what we want to get.
      return `${this.$route.params.type}-${this.$route.params.chapter}-${this.$route.params.number-1}-nombreLibro`;
    },
  },
  async created() {
    var value = await this.$db.options
      .get({
        id: this.dbId,
      })
      .catch(function (error) {
        console.log("error getting option" + error);
      });
    if (value === undefined) return;
    console.log("loaded value");
    console.log(value);

    if (value.option === 1) {
      this.$refs.tg1.style["background-image"] =
        "url(/pages/img/sordo/svgPage71TagLong.svg)";
    } else if (value.option === 2) {
      this.$refs.tg2.style["background-image"] =
        "url(/pages/img/sordo/svgPage71TagLong.svg)";
    } else if (value.option === 3) {
      this.$refs.tg3.style["background-image"] =
        "url(/pages/img/sordo/svgPage71TagLong.svg)";
    } else {
      this.$refs.tg4.style["background-image"] =
        "url(/pages/img/sordo/svgPage71TagLong.svg)";
    }
  },
};
</script>